import { render } from "./MyFeedView.vue?vue&type=template&id=f74fafda"
import script from "./MyFeedView.vue?vue&type=script&lang=js"
export * from "./MyFeedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__